import backendApiClient from "./backendApiClient";
import { extractPlanCart } from "../extractors/planCartExtractor";
import { packPlanCartCheckout } from "../packmans/planCartPackman";

/* istanbul ignore next */
export async function loadSubscriptionPlanCart() {
  return extractPlanCart(
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    await backendApiClient().get("/plan_cart", {
      // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      language: global.configuration.language,
    }),
  );
}

/* istanbul ignore next */
export async function checkoutSubscriptionPlanCart(
  customerPurchaseOrder: $TSFixMe,
  billingAddress: $TSFixMe,
  shippingAddress: $TSFixMe,
  autoCollection: $TSFixMe,
  customerId: $TSFixMe,
) {
  const planCart = packPlanCartCheckout(
    customerPurchaseOrder,
    billingAddress,
    shippingAddress,
    autoCollection,
    customerId,
  );
  return extractPlanCart(
    await backendApiClient().post("/plan_cart/checkout", {
      // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      language: global.configuration.language,
      plan_cart: planCart,
    }),
  );
}

/* istanbul ignore next */
export async function planCartCheckout() {
  return extractPlanCart(
    await backendApiClient().post("/plan_cart/checkout", {
      // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      language: global.configuration.language,
    }),
  );
}

/* istanbul ignore next */
export async function updatePlanCartParameters(updateParameters: $TSFixMe) {
  return extractPlanCart(
    await backendApiClient().patch("/plan_cart", updateParameters),
  );
}

/* istanbul ignore next */
export async function upgradePlanCart() {
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  return backendApiClient().patch("/plan_cart/upgrade");
}
